import React, { useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useData } from '../data/DataProvider';
import { pbEngineer } from '../lib/pb';
import { signInEngineer } from '../lib/auth';
import { Icons } from '../shared/icons';
import SafeIcon from '../common/SafeIcon';

export default function EngineerLogin() {
  const { data } = useData();
  const navigate = useNavigate();
  // The slug from /engineer/login/:tenantSlug is authoritative — at this
  // point there is no session, so data.tenant is still the DEFAULT_TENANT
  // (empty slug) and navigating from it lands on the bare /engineer route.
  const { tenantSlug } = useParams();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email || !password) {
      setError('Please enter your email and password');
      return;
    }

    setLoading(true);
    setError('');

    try {
      const authData = await signInEngineer(email, password);

      if (authData.record.role !== 'engineer') {
        pbEngineer.authStore.clear();
        setError('Access denied: engineer account required');
        setLoading(false);
        return;
      }

      setSuccess(true);
      setTimeout(() => {
        navigate(`/engineer/${tenantSlug || data.tenant.slug}`, { replace: true });
      }, 1000);

    } catch (err) {
      setError(err.message || 'Login failed. Please check your credentials.');
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="standalone-page">
        <div className="success-state">
          <SafeIcon icon={Icons.CheckCircle} />
          <h2>Access Granted</h2>
          <p>Redirecting to engineer portal...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="standalone-page login-page">
      <div className="login-card">
        <div className="login-header">
          <div className="brand-mark">
            <SafeIcon icon={Icons.Wrench} />
          </div>
          <h1>Engineer Portal</h1>
          <p>{data.tenant.name}</p>
        </div>
        
        <form onSubmit={handleSubmit} className="login-form">
          {error && <div className="error-message">{error}</div>}
          
          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              id="email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="engineer@example.com"
              disabled={loading}
            />
          </div>
          
          <div className="form-group">
            <label htmlFor="password">Password</label>
            <input
              id="password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="••••••••"
              disabled={loading}
            />
          </div>
          
          <button type="submit" className="primary-button" disabled={loading}>
            {loading ? 'Signing In...' : 'Access Engineer Portal'}
          </button>
        </form>
        
        <div className="login-footer">
          <SafeIcon icon={Icons.Shield} />
          <p>Authorized personnel only</p>
        </div>
      </div>
    </div>
  );
}